export function joinUrlParams(filterParams: Record<string, any>, url: string): string {
  for (const property in filterParams) {
    if (filterParams[property]) url += `&${property}=${filterParams[property]}`;
  }

  return url;
}
